// based on ../spec/schema/mlt_tileset_metadata.proto
export const ColumnScope = {
    FEATURE: 0,
    VERTEX: 1,
};
export const ScalarType = {
    BOOLEAN: 0,
    INT_8: 1,
    UINT_8: 2,
    INT_32: 3,
    UINT_32: 4,
    INT_64: 5,
    UINT_64: 6,
    FLOAT: 7,
    DOUBLE: 8,
    STRING: 9,
};
export const ComplexType = {
    GEOMETRY: 0,
    STRUCT: 1,
};
export const LogicalScalarType = {
    ID: 0,
};
export const LogicalComplexType = {
    BINARY: 0,
    RANGE_MAP: 1,
};
//# sourceMappingURL=tilesetMetadata.js.map